import { Alert, Skeleton, TableCell, TableRow } from "@mui/material";
import { FormDataConsumer, SelectInput, required } from "react-admin";
import { IecConfigInfo, RampTestKey } from "../types";

type Props = {
  rampTestKey: RampTestKey;
  iecConfigInfo: IecConfigInfo;
  chronicleFilenameDefaultValue?: string;
};

const ChronicleFilenameRow = ({ rampTestKey, iecConfigInfo, chronicleFilenameDefaultValue }: Props) => {
  const { iecConfigChoices, iecConfigsLoading, iecConfigsError } = iecConfigInfo;
  const iecAvailable =
    !iecConfigsLoading && !iecConfigsError && Array.isArray(iecConfigChoices) && iecConfigChoices.length > 0;

  return (
    <FormDataConsumer>
      {({ formData }) => {
        const afrrActive =
          formData?.[rampTestKey]?.afrr_active === undefined ? true : Boolean(formData?.[rampTestKey]?.afrr_active);

        const validators = iecAvailable && afrrActive ? [required()] : [];

        return (
          <TableRow>
            <TableCell size="small" sx={{ fontSize: "1.1rem" }}>
              AFRR Chronicle Filename
            </TableCell>

            {iecConfigsError ? (
              <TableCell size="small" colSpan={3} align="left">
                <Alert severity="error" variant="filled">
                  Could not load chronicle filenames. Check if IEC API is running before running this test.
                </Alert>
              </TableCell>
            ) : (
              <TableCell size="small" colSpan={3} align="left">
                {iecConfigsLoading ? (
                  <Skeleton variant="text" width="100%" height={72} sx={{ py: 0 }} />
                ) : (
                  <SelectInput
                    label={false}
                    source={`${rampTestKey}.chronicle_filename`}
                    choices={iecConfigChoices ?? []}
                    disabled={!afrrActive || !iecAvailable}
                    validate={validators}
                    shouldUnregister={false}
                    defaultValue={chronicleFilenameDefaultValue}
                  />
                )}
              </TableCell>
            )}
          </TableRow>
        );
      }}
    </FormDataConsumer>
  );
};

export default ChronicleFilenameRow;
